import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../state'
import * as display from '../../../../../../display'
import * as variablesBuilder from '../../../../../../variables-builder'

@ngCore.Component({
  imports: [
    display.value.Component,
    ds.input.text.Component,
    ds.input.select.single.Component,
    ds.button.Component,
    ds.layout.widget.Component,
    ds.overlay.centered.Component,
    variablesBuilder.variable.Component,
  ],
  selector: 'atn-widget-builder-variable',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.editingVariables.Feature} */
  private readonly _editingVariablesFeature = ngCore.inject(
    state.admin.editingVariables.Feature,
  )

  /**
   * Currently focused variable definition for editing
   */
  public readonly focusedVariableDefinitionSg = ngCore.computed(
    (focused = this._editingVariablesFeature.selectors.focused.asSignal()) =>
      focused?.definition,
  )

  /**
   * Returns true if existing definition is being updated
   */
  public readonly isUpdatingSg = ngCore.computed(
    (focused = this._editingVariablesFeature.selectors.focused.asSignal()) =>
      // If focused variable definition has an id it means we are editing
      // existing variable
      !!focused?.id,
  )

  /**
   * List of types that can be selected as variable type
   */
  public readonly variableTypeSelectItems: ds.input.select.models.Item[] =
    ents.core.common.value.types.Intrinsic.ALL.map(type => ({
      label: type,
      onSelect: () => this.updateDefinition('type', type),
    }))

  /**
   * If variable type is intrinsic, returns the intrinsic type
   */
  public readonly intrinsicTypeSg = ngCore.computed(
    (focusedVariableDefinition = this.focusedVariableDefinitionSg()) =>
      ents.core.common.value.types.Intrinsic.isIntrinsic(
        focusedVariableDefinition?.type,
      )
        ? focusedVariableDefinition.type
        : undefined,
  )

  public updateDefinition<
    K extends keyof state.variableOverrides.models.Definition,
  >(prop: K, value: state.variableOverrides.models.Definition[K]): void {
    this._editingVariablesFeature.actions.updateFocused
      .from('Variable.Input.Changed')
      .dispatch(definition => ({ ...definition, [prop]: value }))
  }

  public saveClickHandler(): void {
    this._editingVariablesFeature.actions.saveFocused
      .from('Variable.SaveButton.Clicked')
      .dispatch()
  }

  public cancelClickHandler(): void {
    this._editingVariablesFeature.actions.discardFocused
      .from('Variable.CancelButton.Clicked')
      .dispatch()
  }
}
